import { createSlice } from "@reduxjs/toolkit";
import {
  cityState,
  countryState,
  languageState,
  stateState,
} from "../../state";

const getCountrySlice = createSlice({
  name: "GET_COUNTRY_SLICE",
  initialState: countryState,
  reducers: {
    startCountryData: (state) => {
      state.countryLoading = true;
      state.countryError = null;
    },
    successCountry: (state, action) => {
      state.countryLoading = false;
      state.country = action.payload.payload;
    },
    errorCountry: (state, action) => {
      state.countryLoading = false;
      state.countryError = action.payload;
    },
  },
});

const getStateSlice = createSlice({
  name: "GET_STATE_SLICE",
  initialState: stateState,
  reducers: {
    startState: (state) => {
      state.stateLoading = true;
      state.stateError = null;
    },
    successState: (state, action) => {
      state.stateLoading = false;
      state.state = action.payload.payload;
    },
    errorState: (state, action) => {
      state.stateLoading = false;
      state.stateError = action.payload;
    },
  },
});

const getCitySlice = createSlice({
  name: "GET_CITY_SLICE",
  initialState: cityState,
  reducers: {
    startCity: (state) => {
      state.cityLoading = true;
      state.cityError = null;
    },
    successCity: (state, action) => {
      state.cityLoading = false;
      state.city = action.payload.payload;
    },
    errorCity: (state, action) => {
      state.cityLoading = false;
      state.cityError = action.payload;
    },
  },
});

const getLanguageSlice = createSlice({
  name: "GET_LANGUAGE_SLICE",
  initialState: languageState,
  reducers: {
    startLanguage: (state) => {
      state.languageLoading = true;
      state.languageError = null;
    },
    successLanguage: (state, action) => {
      state.languageLoading = false;
      state.language = action.payload.payload;
    },
    errorLanguage: (state, action) => {
      state.language = false;
      state.languageError = action.payload;
    },
  },
});

export const { startCountryData, successCountry, errorCountry } =
  getCountrySlice.actions;

export const { startState, successState, errorState } = getStateSlice.actions;
export const { startCity, successCity, errorCity } = getCitySlice.actions;
export const { startLanguage, successLanguage, errorLanguage } =
  getLanguageSlice.actions;

export const getCountryReducer = getCountrySlice.reducer;
export const getStateReducer = getStateSlice.reducer;
export const getCityReducer = getCitySlice.reducer;
export const getLanguageReducer = getLanguageSlice.reducer;
